<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="shrink-0" :class="$attrs.class">
    <rect x="4" y="14" width="6" height="6" rx="1"/>
    <rect x="14" y="14" width="6" height="6" rx="1"/>
    <rect x="9" y="8" width="6" height="6" rx="1"/>
    <rect x="4" y="2" width="6" height="6" rx="1"/>
    <rect x="14" y="2" width="6" height="6" rx="1"/>
  </svg>
</template>
<script setup>defineOptions({ inheritAttrs: false });</script>
